<template>
<div>
  <div class="content">
    <div class="cont-list">
      <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
      <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
    </div>
    <div class="header">
      <div class="left">
        <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
        <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button> -->

        <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
      </div>
      <div class="right">
        <el-button class="btn primary" type="primary" style="margin-right: 10px" @click="showTransfer">自定义设置</el-button>
        <div class="search">
          <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
            <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
          </el-input>
          <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
        </div>
        <span v-preventReClick @click="reset">重置</span>
      </div>
    </div>

    <div v-if="tableHaeder.length > 0">
      <CustomTable ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading" @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name">
        <template slot="before">
          <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
          </el-table-column>
        </template>
        <template slot="after">
          <el-table-column fixed="right" prop="operation" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
              <el-button v-if="
                  scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)
                " type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
              <el-button v-else-if="
                  scope.row.status != 1 &&
                  scope.row.status != 2 &&
                  tableAcl.indexOf('Edit') != -1
                " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
              <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
              <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button> -->
              <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
            </template>
          </el-table-column>
        </template>
      </CustomTable>
    </div>
    <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column width="170" prop="no" label="跟台使用单号">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{
                  scope.row.no
                  }}</el-link>
            </span>
          </template>
        </el-table-column>

        <el-table-column width="170" prop="createdTime" label="创建时间">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column>
        <el-table-column width="120" prop="warehouseName" label="仓库"></el-table-column>
        <el-table-column width="120" prop="patientName" label="患者姓名"></el-table-column>
        <el-table-column width="120" prop="deptName" label="执行科室"></el-table-column>
        <el-table-column width="120" prop="chargeCategoryName" label="计费类型"></el-table-column>
        <el-table-column width="120" prop="surgicalStentCategroyName" label="手术类型">
          <template slot-scope="scope">
            {{
                (scope.row.surgicalStentName ? scope.row.surgicalStentName : "") +
                " " +
                (scope.row.surgicalStentCategroyName
                  ? scope.row.surgicalStentCategroyName
                  : "-")
              }}
          </template>
        </el-table-column>
        <el-table-column width="120" prop="chargeNo" label="计费单号"></el-table-column>
        <el-table-column width="120" prop="totalNumber" label="总数量"></el-table-column>
        <el-table-column width="120" prop="totalAmount" label="总金额"></el-table-column>
        <el-table-column prop="remark" label="备注">
          <template slot-scope="scope">
            {{ scope.row.remark ? scope.row.remark : "-" }}
          </template>
        </el-table-column>
        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames">
          <template slot-scope="scope">
            {{ scope.row.approverNames ? scope.row.approverNames : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <el-button v-else-if="
                scope.row.status != 1 &&
                scope.row.status != 2 &&
                tableAcl.indexOf('Edit') != -1
              " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
            <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button> -->
            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
  <div class="pagination">
    <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
    </el-pagination>
  </div>
  <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
</div>
</template>

<script>
import {
  GetSurgicalUses,
  RemoveSurgicalUse
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  ChargeCategoryOptions,
  ApproveStatusOptions
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      GetDatasAction: GetSurgicalUses,
      RemoveAction: RemoveSurgicalUse,
      // PrintAction: GetAcceptInStockPrintData,
      editPath: "surgical-use-edit",

      ChargeCategoryOptions: ChargeCategoryOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      filterOptions: [{
          name: "患者科室",
          type: "select",
          code: "deptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "单号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "住院号",
          type: "input",
          code: "patientNo",
        },
        {
          name: "供货商产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "计费类型",
          type: "select",
          code: "chargeCategory",
          data: ChargeCategoryOptions,
        },
        {
          name: "计费科室",
          type: "select",
          code: "chargeDeptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "流程状态",
          type: "select",
          code: "statuses",
          multiple: true,
          data: ApproveStatusOptions,
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
        {
          name: "主条码",
          type: "input",
          code: "mainNo",
        },
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
